<template>
  <div>
    <el-form ref="formData" :model="formData" label-width="100px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="反馈时间" prop="logTime">
            <el-date-picker
              v-model="formData.logTime"
              type="datetime"
              placeholder="请选择反馈时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%;"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="司机信息" prop="driverName">
            <dict-select
              v-model="formData.driverName"
              clearable
              url="/carrier/driver/info/select"
              placeholder="请选择司机"
              filterable
              :selectedLabel.sync="formData.driverName"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="省/市/区县" prop="cityCode">
            <region-cascader
              v-if="regionShow"
              ref="regionCascader"
              :show="regionShow"
              :props="{checkStrictly: true}"
              :provinceCode.sync="formData.provinceCode"
              :provinceName.sync="formData.provinceName"
              :cityCode.sync="formData.cityCode"
              :cityName.sync="formData.cityName"
              :districtCode.sync="formData.districtCode"
              :districtName.sync="formData.districtName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实时地点" prop="logPlace">
            <el-input v-model="formData.logPlace" placeholder="请输入实时地点">
              <el-button
                slot="append"
                icon="el-icon-map-location"
                @click="() => (coordPickerDialogVisible = true)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上报客户" prop="isSendCustomer">
            <el-select
              style="width:100%"
              v-model="formData.isSendCustomer"
              placeholder="请选择是否是上报客户"
            >
              <el-option label="是" value="Y" />
              <el-option label="否" value="N" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="节点标题" prop="logTitle">
            <dict-select
              clearable
              v-model="formData.logTitle"
              placeholder="请选择节点标题"
              default
              filterable
              size="small"
              style="width:100%"
              :body="logTitleDictParams"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="反馈内容" prop="logDesc">
        <el-input
          v-model="formData.logDesc"
          type="textarea"
          :rows="4"
          maxlength="1000"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="反馈图片">
        <!-- style="height: 300px; overflow-y: scroll;" -->
        <div>
          <el-upload
            ref="uploader"
            action="#"
            list-type="picture-card"
            :auto-upload="false"
            :on-preview="onUploadPreview"
            :on-change="onUploadChange"
            accept="image/png,image/jpeg"
            multiple
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <coord-picker-dialog
      :visible.sync="coordPickerDialogVisible"
      :address.sync="formData.logPlace"
      :longitude.sync="formData.logLongitude"
      :latitude.sync="formData.logLatitude"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    listOrder: {type: Array, default: () => []},
  },
  data() {
    return {
      logTitleDictParams: {type: 'logTitle'},
      viewer: null,
      coordPickerDialogVisible: false,
      formData: {},
      regionShow: true,
      rules: {
        logTime: [
          {required: true, message: '请选择反馈时间', trigger: 'change'},
        ],
        isSendCustomer: [
          {required: true, message: '请选择上报客户', trigger: 'change'},
        ],
        cityCode: [
          {
            required: true,
            message: '请至少选择到城市',
            trigger: 'change',
          },
        ],
      },
      listImage: [],
    }
  },

  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      const listCode = this.listOrder.map((item) => item.waybillDetailCode)
      const listImage = await this.uploadImages()
      const params = {...this.formData, listImage, listCode}
      this.$api
        .carrierWaybillServiceFeedbackApi(params)
        .then((res) => {
          loadingInstance.close()
          this.$emit('close')
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    uploadImages() {
      if (!this.listImage || !this.listImage.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImage.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          imageCode: res.body.id,
          imageUrl: res.body.url,
        }))
      })
      return Promise.all(uploadTask)
    },
    onUploadChange(file, fileList) {
      this.listImage = fileList
    },
    onImageRemove(file) {
      this.$refs.uploader.handleRemove(file)
    },
    onUploadPreview(file) {
      const index = this.listImage.findIndex((i) => {
        return i.uid == file.uid
      })
      if (this.listImage.length > 0) {
        this.viewer = this.$el.querySelector('.uploadImages').$viewer
        this.viewer.view(index)
        this.viewer.show()
      }
    },
    clearFiles() {
      this.$refs['uploader'].clearFiles()
    },
  },
}
</script>
